import { connect } from 'react-redux'

import Nav from 'modules/Nav/index'
import authSelector from 'modules/Auth/selectors'

import {getUserPermissions} from 'modules/Auth/actions'

const mapStateToProps = (state) => ({
      userData: authSelector.getUserInfo(state),
    permissions : authSelector.getUserPermissions(state)
})
const mapDispatchToProps = {
    getUserPermissions

}

export default connect(mapStateToProps, mapDispatchToProps)(Nav)
